import React, { useEffect, useState } from "react";
import { Grid, IconButton, LinearProgress, Link, Typography } from "@material-ui/core";
import { RaceEntryOverviewStartGroup, RaceEntryOverviewStartGroupDetailCompany } from "../../../../model/RaceEntryOverview";
import { KeyboardArrowDown, KeyboardArrowUp } from "@material-ui/icons";
import { ApiBackend } from "../../../../providers/apibackend";
import { RouteComponentProps, withRouter } from "react-router";
import { undefinedNumberFormatter } from "./utils";

type Props = {
    raceId: string;
    group: RaceEntryOverviewStartGroup;
    item: RaceEntryOverviewStartGroupDetailCompany;
};

const EntryStatItemDetails = (props: Props & RouteComponentProps) => {
    const [data, setData] = useState<RaceEntryOverviewStartGroupDetailCompany[]>(null);
    const [loading, setLoading] = useState(false);
    const [expanded, setExpanded] = useState(false);

    const itemStyle = { paddingBottom: 0, paddingTop: 0 };
    const api = new ApiBackend();

    useEffect(() => {
        if (!expanded) {
            return;
        }

        fetchData();

    }, [expanded]);

    const render = () => {
        const { item } = props;

        return (<>
            <Grid item xs={4} style={itemStyle}>
                <IconButton size="small" onClick={handleExpandClick}>
                    {expanded ? (
                        <KeyboardArrowUp />
                    ) : (
                        <KeyboardArrowDown />
                    )}
                </IconButton>
                <Link href={`/companies/manage/${item.id}`} variant="body2" color="secondary" underline="always">
                    {item.name}
                </Link>
            </Grid>
            <Grid item xs={4} style={itemStyle}>
                <Typography variant="body2" style={{ fontWeight: "bold", lineHeight: "30px" }}>{undefinedNumberFormatter(item.numCompanyRegistered)}</Typography>
                {/* <b>{undefinedNumberFormatter(item.numCompanyRegistered)}</b> */}
            </Grid>
            <Grid item xs={4} style={itemStyle}>
                <Typography variant="body2" style={{ fontWeight: "bold", lineHeight: "30px" }}>{undefinedNumberFormatter(item.numCompanyReserved)}</Typography>
                {/* <b>{undefinedNumberFormatter(item.numCompanyReserved)}</b> */}
            </Grid>
            {expanded && (
                <Grid item xs={12}>
                    {renderDetails()}
                </Grid>
            )}
        </>);
    };

    const renderDetails = () => {
        // , backgroundColor: "#efefef"
        const evenColor = "#e8e8e8";
        const oddColor = "#dedede";

        return (
            <Grid container style={{ paddingTop: 10, paddingBottom: 10 }}>
                <Grid item xs={4} style={{ fontWeight: "bold", paddingLeft: "30px" }}>
                    <Typography variant="body2" style={{ fontWeight: "bold" }}>Reservationsnamn</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontWeight: "bold" }}>
                    <Typography variant="body2" style={{ fontWeight: "bold" }}>Antal deltagare</Typography>
                </Grid>
                <Grid item xs={4} style={{ fontWeight: "bold" }}>
                    <Typography variant="body2" style={{ fontWeight: "bold" }}>Antal otilldelade</Typography>
                </Grid>

                {loading &&
                    <Grid item xs={12}>
                        <LinearProgress color="secondary" />
                    </Grid>
                }

                {data && data.map((item, idx) => {
                    return (
                        <Grid item xs={12}>
                            <Grid key={idx} container style={{ backgroundColor: idx % 2 ? evenColor : oddColor }}>
                                <Grid item xs={4} style={{ paddingLeft: "30px" }}>
                                    <Typography variant="body2">{item.name}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body2" style={{ fontWeight: "bold" }}>{undefinedNumberFormatter(item.numCompanyRegistered)}</Typography>
                                </Grid>
                                <Grid item xs={4}>
                                    <Typography variant="body2" style={{ fontWeight: "bold" }}>{undefinedNumberFormatter(item.numCompanyReserved)}</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                    );
                })}
            </Grid>
        )
    };

    const handleExpandClick = () => {
        setExpanded(!expanded);
    };

    const fetchData = async () => {
        const { raceId, group, item } = props;

        setLoading(true);

        try {
            const details = await api.getEntryOverviewDetails(raceId, group.id, item.id);
            setData(details?.items);
            console.log(details);
        } finally {
            setLoading(false);
        }
    };

    return render();
};

export default withRouter(EntryStatItemDetails);
